import script from "./TestimonialComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonialComponent.vue?vue&type=script&setup=true&lang=js"

import "./TestimonialComponent.vue?vue&type=style&index=0&id=6dbe5cc8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dbe5cc8"]])

export default __exports__